export default __webpack_public_path__ + "static/media/m3.30def7e8.svg";